import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';
import type { MydayType } from './useMyday';

export const useMydays = (page = 1, limit = 10, type?: string) => {
  return useQuery({
    queryKey: ['useMydays', page, limit, type],
    queryFn: () =>
      axios
        .get(`${envApiUrl}/mydays/`, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
          params: { page, limit, ...(type && { type }) },
        })
        .then((response) => {
          return response.data as {
            data: MydayType[];
            pagination: {
              page: number;
              limit: number;
              total: number;
              totalPages: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
            };
          };
        })
        .catch((error) => {
          if (error.response) {
            console.log('AAA: ', error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
          throw error; // Re-throw to let React Query handle the error state
        }),
    staleTime: 0, // Always consider data stale for pagination
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: true, // Refetch on mount for pagination
  });
};
